import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const ReporterTypeContext = createContext();

export default function ReporterTypeProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentReporterTypes, setCurrentReporterTypes] = useState([]);

  const updateReporterTypes = async () => {
    try {
      logger.debug(
        "ReporterTypeProvider.updateReporterType",
        `GET field/workOrder/reportertype`
      );

      const data = await auth.get(`field/workOrder/reportertype`);

      logger.debug("ReporterTypeProvider.updateReporterType", `Retrieved data`);

      const sortedData = data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });

      setCurrentReporterTypes(sortedData);
      return sortedData;
    } catch (error) {
      setCurrentReporterTypes([]);
      return [];
    }
  };

  const getReporterTypes = () => currentReporterTypes;

  return (
    <ReporterTypeContext.Provider
      value={{
        getReporterTypes,
        updateReporterTypes,
      }}
    >
      {children}
    </ReporterTypeContext.Provider>
  );
}

ReporterTypeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useReporterType = () => useContext(ReporterTypeContext);
